import styled from '@emotion/styled'
import { Container, Header as BaseHeader } from 'consumer-mobile-web/components/Header'
import spacing from 'design-system/tokens/spacing'

const HeaderContainer = styled(Container)`
  padding: ${spacing.xxxs} ${spacing.s};
  box-sizing: border-box;
`

const Header = () => {
  return (
    <HeaderContainer>
      <BaseHeader />
    </HeaderContainer>
  )
}

export default Header
